import { useMemo } from 'react';

import useCourseOpportunitiesLXP from '../../graphql/useCourseOpportunitiesLXP';

const useStillValidSkills = persistedSelectedSkills => {
  const { loading: isLoading, data: followedOpportunities, error } = useCourseOpportunitiesLXP();

  const stillValidSkills = useMemo(() => {
    if (error || isLoading || !followedOpportunities || !persistedSelectedSkills) {
      return null;
    }

    return persistedSelectedSkills.filter(({ skillId }) => {
      const allSkillGaps = followedOpportunities.map(({ skillsGap }) => skillsGap).filter(Boolean);
      const skillGapWithTargetSkill = allSkillGaps.find(gap =>
        gap.find(gapSkill => gapSkill._id === skillId)
      );
      return skillGapWithTargetSkill !== undefined;
    });
  }, [persistedSelectedSkills, followedOpportunities, error, isLoading]);

  return {
    isLoading,
    stillValidSkills,
  };
};

export default useStillValidSkills;
